import { render, staticRenderFns } from "./checklist-template-editor.vue?vue&type=template&id=0060f6d3"
import script from "./checklist-template-editor.vue?vue&type=script&lang=js"
export * from "./checklist-template-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports